




























































import Vue, { PropOptions } from 'vue';
import SToolbar from '../SToolbar/SToolbar.vue';
import SToolbarTitle from '../SToolbarTitle/SToolbarTitle.vue';
import themes from '../../styles/themes';

import { BreadCrumb } from '../../types';

export default Vue.extend({
  name: 'SHeader',
  components: {
    SToolbar,
    SToolbarTitle,
    SInfo: () => import('../SInfo/SInfo.vue'),
  },
  props: {
    /**
     * @see src/components/SInfo/SInfo.vue#id
     */
    id: {
      type: String,
      required: false,
    },
    /**
     * Will be used to work out the header color of the `SToolbar` component if the `color` prop is
     * not present
     *
     * @see src/components/SToolbar/SToolbar.vue#theme
     * @see src/components/SToolbarTitle/SToolbarTitle.vue#theme
     * @see src/components/SInfo/SInfo.vue#theme
     */
    theme: {
      type: String,
      required: false,
    },
    /**
     * @see src/components/SToolbarTitle/SToolbarTitle.vue#title
     * @see src/components/SInfo/SInfo.vue#title
     */
    title: {
      type: String,
      required: true,
    },
    /**
     * @see src/components/SToolbarTitle/SToolbarTitle.vue#subTitle
     */
    subTitle: {
      type: String,
      required: false,
    },
    /**
     * If truthy will display the `SInfo` component
     * @see src/components/SInfo/SInfo.vue#description
     */
    description: {
      type: String,
      required: false,
    },
    /**
     * @see src/components/SInfo/SInfo.vue#subDescription
     */
    subDescription: {
      type: String,
      required: false,
    },
    /**
     * Will be used to work out the header color of the `SToolbar` component if provided.
     */
    color: {
      type: String,
      required: false,
    },
    /**
     * @see src/components/SToolbarTitle/SToolbarTitle.vue#icon
     */
    icon: {
      type: String,
      required: false,
    },
    /**
     * @see src/components/SToolbarTitle/SToolbarTitle.vue#showIcon
     */
    showIcon: {
      type: Boolean,
      required: false,
      default: true,
    },
    /**
     * @see src/components/SToolbar/SToolbar.vue#dense
     * NOTE: You might prefer the 'small' prop as it also reduces the height
     */
    dense: {
      type: Boolean,
      required: false,
      default: true,
    },
    /**
     * @see src/components/SToolbarTitle/SToolbarTitle.vue#breadcrumbs
     */
    breadcrumbs: {
      required: false,
      type: Array,
    } as PropOptions<BreadCrumb[]>,
    /**
     * @see src/components/SToolbar/SToolbar.vue#useLightToolbar
     */
    useLightToolbar: {
      type: Boolean,
      default: false,
    },
    /**
     * @see src/components/SInfo/SInfo.vue#tooltipColor
     */
    tooltipColor: {
      type: String,
      default: 'primary',
    },
    /**
     * Reduce the height of the header
     */
    small: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    headerColor(): string {
      if (this.color) return this.color;
      if (this.theme && themes[this.theme]) return themes[this.theme].header;
      return '';
    },
  },
});
